var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4551 14.1417C22.9224 14.1417 24.1119 12.9522 24.1119 11.4849C24.1119 10.0176 22.9224 8.82812 21.4551 8.82812C19.9878 8.82812 18.7983 10.0176 18.7983 11.4849C18.7983 12.9522 19.9878 14.1417 21.4551 14.1417Z",
    stroke: "#3E3E3E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.545 19.6573C14.0123 19.6573 15.2018 18.4679 15.2018 17.0005C15.2018 15.5332 14.0123 14.3438 12.545 14.3438C11.0777 14.3438 9.88818 15.5332 9.88818 17.0005C9.88818 18.4679 11.0777 19.6573 12.545 19.6573Z",
    stroke: "#3E3E3E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4551 25.173C22.9224 25.173 24.1119 23.9835 24.1119 22.5162C24.1119 21.0489 22.9224 19.8594 21.4551 19.8594C19.9878 19.8594 18.7983 21.0489 18.7983 22.5162C18.7983 23.9835 19.9878 25.173 21.4551 25.173Z",
    stroke: "#3E3E3E",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2104 12.9062L14.8047 15.6059",
    stroke: "#3E3E3E",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 18.3984L19.2104 21.0952",
    stroke: "#3E3E3E",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.b8e45194.svg";
export { ForwardRef as ReactComponent };